module.exports = __webpack_public_path__ + "static/media/7p.7b5401ce.jpg";